import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '@dbk/ui-toggle';
import Text from '@dbk/ui-text';

const MATURITY_7DAYS = "maturities.7days";
const REPORTS = "reports";
const CIO = "cio";
const ESIGNATURE = "esignature";
const INVESTMENT = "investmentideas"
const MULTISIG = "multisigpayments"

const NotificationItem = (props) => {
  const { item: { alertType, value }, messages, handleClick } = props;
  let title = '';
  let checked = false;

  switch (alertType) {
    case MATURITY_7DAYS:
      title = messages['app.profile.notification.maturity'];
      break;
    case REPORTS:
      title = messages['app.profile.notification.Statement'];
      break;
    case CIO:
      title = messages['app.profile.notification.CIO'];
      break;
    case ESIGNATURE:
      title = messages['app.docsign.eSignatureText'];
      break;
    case INVESTMENT:
      title = messages['app.common.pageTitle.investmentsIdeas'];
      break;
    case MULTISIG:
      title = messages['app.profile.notification.MultiSigApproval'];
      break;
  }

  switch (value) {
    case 'T':
      checked = true;
      break;
    case 'F':
      checked = false;
      break;
  }

  return (
    <div className="notification-settings__list-item">
      <Text size="large" id="text_notificationSettings_notificationItem_test" aria-label={title} tabIndex={0}>{title}</Text>
      <div className="notification-settings__toggle-wrapper" id="icon_notificationSettings_notificationItem_test">
        <Toggle testID={''} ariaLabel={title +" "+checked} checked={checked} />
      </div>
    </div>
  );
}

NotificationItem.propTypes = {
  handleClick: PropTypes.func,
  checked: PropTypes.bool,
  messages: PropTypes.array,
  item: PropTypes.shape({
    alertType: PropTypes.string,
    value: PropTypes.string
  })
};

NotificationItem.defaultProps = {
  handleClick: () => { },
  checked: false,
  messages: [],
  item: {
    alertType: '',
    vlaue: ''
  }
};

export default NotificationItem;
